<div class="bonus-reward-container">
  <div
    class="bonus-reward-background-image"
    [ngStyle]="{ 'background-image': 'url(' + data.properties.imageUrl + ')' }">
    <div class="bonus-reward-rewards">
      @if (reward.credits) {
        <div class="bonus-reward-content">
          <div
            class="bonus-reward-display-icon"
            theming
            themingGroup="none"
            themingAsset="credits"></div>
          <div class="bonus-reward-display">
            <div class="bonus-reward-display-value">{{ reward.credits | number }}</div>
          </div>
        </div>
      }

      @if (reward.gems) {
        <div class="bonus-reward-content">
          <div
            class="bonus-reward-display-icon"
            theming
            themingGroup="none"
            themingAsset="gems"></div>
          <div class="bonus-reward-display">
            <div class="bonus-reward-display-value">{{ reward.gems | number }}</div>
          </div>
        </div>
      }
    </div>
  </div>

  @if (data.properties.closeable) {
    <slotcom-navigation-button
      type="close"
      (click)="closeModal()" />
  }

  <div class="bonus-reward-unlock-games">
    @for (gameIcon of gameIcons(); track gameIcon) {
      <div
        class="bonus-reward-unlock-game-icon"
        [style.background-image]="'url(' + gameIcon + ')'"></div>
    }
  </div>

  <div class="button-container">
    <slotcom-button
      class="c-button--pink"
      (safeClick)="redeemBonus(data.properties.actionUrl)"
      audioType="reward">
      {{ data.properties.buttonText ?? ('home.buttons.accept' | translate | uppercase) }}
    </slotcom-button>
  </div>
</div>
